import { ProfileService } from "@/common/api/profile.service";
import {
  PROFILE_GET,
  PROFILE_UPDATE,
  // PROFILE_DAYS_OFF_GET,
  PROFILE_LOGO_GET,
  PROFILE_CEP_SEARCH,
} from "./actions/profile.type";
import { CHANGE_PROGRESS, CHRANGE_SNACK } from "./mutations/mutations.type";
import {
  SET_PROFILE,
  // SET_DAYS_OFF,
  // PROFILE_ADD_WEEKDAY,
  // PROFILE_REMOVE_WEEKDAY,
  SET_LOGO,
  PROFILE_RESET_STATE,
  SET_CEP
} from "./mutations/profile.type";

const initialState = () => {
  return {
    profile: {
      name: "",
      cnpj: "",
      companyName: "",
      fantasyName: "",
      phone: "",
      email: "",
      state: "",
      city: "",
      district: "",
      street: "",
      number: 0,
      addressComplement: "",
      zipcode: ""
      // weekDays: [],
      // dayOffs: []
    },
    logo: null,
    cep: {
      bairro: '',
      cidade: '',
      logradouro: '',
      uf: ''
    }
  };
};

export const state = initialState();

const getters = {
  profile: state => {
    return state.profile;
  },
  logo: state => {
    return state.logo;
  },
  cep: state => {
    return state.cep;
  }
};

const mutations = {
  [SET_PROFILE](state, data) {
    state.profile = data;
  },
  [SET_LOGO](state, data) {
    state.logo = data;
  },
  [PROFILE_RESET_STATE](state) {
    Object.assign(state, initialState());
  },
  [SET_CEP](state, data) {
    state.profile.street = data.logradouro;
    state.profile.district = data.bairro;
    state.profile.city = data.cidade;
    state.profile.state = data.uf;
  }
};

const actions = {
  async [PROFILE_GET]({ commit }) {
    commit(CHANGE_PROGRESS, true);
    const { data } = await ProfileService.get();
    commit(SET_PROFILE, data);
    commit(CHANGE_PROGRESS, false);
  },

  async [PROFILE_CEP_SEARCH]({ commit }, cep) {
    commit(CHANGE_PROGRESS, true);
    const { data } = await ProfileService.getCep(cep);
    commit(SET_CEP, data);

    const isEmpty = Object.values(data).every((value) => {
      return value === ""
    });

    if (isEmpty) {
      commit(CHRANGE_SNACK, {
        snackbar: true,
        text: "CEP não encontrado",
        color: "error"
      })
    } else {
      commit(CHRANGE_SNACK, {
        snackbar: true,
        text: "CEP encontrado",
        color: "success"
      })
    }
    commit(CHANGE_PROGRESS, false);
  },

  async [PROFILE_UPDATE]({ state }) {
    return ProfileService.update("", state.profile);
  },

  async [PROFILE_LOGO_GET]({ commit }) {
    // commit(CHANGE_PROGRESS, true);
    const data = await ProfileService.get_logo();
    commit(SET_LOGO, data);
    // commit(CHANGE_PROGRESS, false);
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
